import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useToast = () => {
  const options = {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    limit: 1, // Limit the number of toasts displayed at a time
  };

  const toastSuccess = (message) => {
    toast.dismiss(); // Dismiss any existing toasts
    return toast.success(message, options);
  };

  const toastError = (message) => {
    toast.dismiss(); // Dismiss any existing toasts
    return toast.error(message, options);
  };

  const toastInfo = (message) => {
    toast.dismiss(); // Dismiss any existing toasts
    toast.info(message, options);
  };

  const toastWarning = (message) => {
    toast.dismiss(); // Dismiss any existing toasts
    toast.warning(message, options);
  };

  return { toastSuccess, toastInfo, toastError, toastWarning };
};

export default useToast;
